export default __webpack_public_path__ + "static/media/rgs_medium@2x.0408c9bf.jpg";